const ROUTES = {
    LANDING: '/',
    SIGN_UP: '/signup',
    SIGN_IN: '/signin',
    HOME: '/home',
    ACCOUNT: '/account',
    PASSWORD_FORGET: '/pw-forget',
    ADMIN: '/admin',
    ADMIN_DETAILS: '/admin/:id',
    LEADS: '/leads',
    APPOINTMENTS: '/appointments',
    CONTACTS: '/contacts',
    MAINTAINENCE: '/maintenance',
    PAYMENTS: '/payments',
    PRODUCTS: '/products',
}

export default ROUTES